const CartItem = require('./cart.item');

class CartDictionary {
    constructor(items = []) {
        this.items = {};

        items.forEach((item) => this.addItem(item));
    }

    get length() {
        return Object.keys(this.items).length;
    }

    hasItem(name) {
        return Object.prototype.hasOwnProperty.call(this.items, name);
    }

    addItem(data = {}) {
        const {name} = data;
        this.items[name] = new CartItem(data);
    }

    addItems(items = []) {
        items.forEach(({data}) => this.addItem(data));
    }

    removeItem(name) {
        return this.hasItem(name) ? this.deleteItem(name) : null;
    }

    removeItems(items = []) {
        items.forEach(({data}) => this.removeItem(data.name));
    }

    deleteItem(name) {
        const item = this.items[name];

        delete this.items[name];

        return item.data;
    }

    getItem(name) {
        return this.items[name];
    }

    isEveryItemCommitted() {
        return this.isEveryItemInState(true);
    }

    isEveryItemNotCommitted() {
        return this.isEveryItemInState(false);
    }

    isEveryItemInState(state = false) {
        return Object.entries(this.items).every(([name, item]) => item.committed === state);
    }

    getNotCommittedItems(filter = () => true) {
        return this.getItemsInState(filter, false);
    }

    getCommittedItems(filter = () => true) {
        return this.getItemsInState(filter, true);
    }

    getItemsInState(filter = () => true, state = false) {
        return Object.values(this.items)
            .filter((item) => item.committed === state)
            .map(({data}) => data)
            .filter(filter);
    }

    getRawItems(filter = () => true) {
        return Object.values(this.items)
            .filter(filter);
    }

    getItems(filter = () => true) {
        return Object.values(this.items)
            .map(({data}) => data)
            .filter(filter);
    }

    setToBeRestored() {
        return Object.values(this.items).map((item) => item.setToBeRestored(true));
    }
}

module.exports = CartDictionary;
